import { HttpClient, HttpEventType } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  OnInit,
  ViewChild,
  Output,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  FileuploadProgressbarService,
  FileQueueObject,
} from 'src/app/resuable/fileupload-progressbar/fileupload-progressbar.service';
import { takeUntil } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ApiUrls, Doctypes } from 'src/app/shared/api-urls';
import { SocketService } from 'src/app/shared/services/socket.service';

@Component({
  selector: 'app-bulk-upload-excel-progressbar',
  templateUrl: './bulk-upload-excel-progressbar.component.html',
  styleUrls: ['./bulk-upload-excel-progressbar.component.scss'],
})
export class BulkUploadExcelProgressbarComponent implements OnInit {
  private destroyEvents: EventEmitter<boolean> = new EventEmitter();
  @Output() item = new EventEmitter();

  excelUploadData = {
    totalCount: 0,
    createdCount: 0,
    status: '',
  };
  isPurchaseSocket: boolean = false;

  purchaseExcelUploadData = {
    totalCount: 0,
    createdCount: 0,
    status: '',
  };
  uploadProgress = {
    status: 'NO',
    progress: 0,
    label: 'Uploading',
    color: 'secondary',
    data: null,
    file_type: null,
  };
  uploadPurchaseProgress = {
    status: 'NO',
    progress: 100,
    label: 'Uploading',
    color: 'primary',
    data: null,
    completed: false,
  };

  execeptionError = false;
  execptionData;

  // uploadingType: any = 'dynamic';

  // isPurchaseImport: any;
  hasPurchaseErrors: any = {
    status: false,
    message: '',
  };

  socketName: any = null;
  companyInfo: any;
  constructor(private socketService: SocketService) {}

  ngOnInit(): void {
    const loadCompanyInfo = () =>
      new Promise((resolve, reject) => {
        const companyInfo = JSON.parse(localStorage.getItem('company'));
        if (companyInfo && companyInfo.company_code) {
          resolve(companyInfo);
        } else {
          reject('Company info not found or invalid.');
        }
      });

    loadCompanyInfo()
      .then((info) => {
        this.companyInfo = info;
        console.log(this.companyInfo, '/companyInfo');
      })
      .catch((error) => {
        console.error(error);
      });

    this.socketService.newInvoice
      .pipe(takeUntil(this.destroyEvents))
      .subscribe((res: any) => {
        console.log(' newInvoice Sockect === ', res);
        console.log(res?.message?.type, '74 line === ', res?.message);
        if (res?.message?.type === 'Bulk_file_pr_invoice_created') {
          console.log(' PR Continue  log', res?.message);
          this.uploadProgress.status = 'STARTED';
          this.uploadProgress.label = 'Uploading Files';
          this.uploadProgress.color = 'secondary';
          this.uploadProgress.file_type = 'PR File';
          setTimeout(() => {
            this.uploadProgress.status = 'SUCCESS';
            this.excelUploadData.createdCount = 0;
            this.excelUploadData.totalCount = 0;
          }, 1000);
        }

        if (res?.message?.type === 'Bulk_file_pr_invoice_created_Completed') {
          console.log(' PR Completed  log', res?.message);
          this.uploadProgress.progress = 100;
          this.uploadProgress.color = 'success';
          this.uploadProgress.label = 'Finalize PR Successful';
          this.uploadProgress.file_type = 'PR File';
          setTimeout(() => {
            this.uploadProgress.status = 'SUCCESS';
            this.excelUploadData.createdCount = 0;
            this.excelUploadData.totalCount = 0;
          }, 1000);
        }
        if (res?.message?.type === 'purchase_import_file') {
          console.log('started', res?.message?.type);
          this.isPurchaseSocket = true;
          this.uploadPurchaseProgress.status = 'STARTED';
          this.uploadPurchaseProgress.label = 'Uploading Files';
          this.uploadPurchaseProgress.color = 'secondary';
          this.purchaseExcelUploadData.totalCount = res?.message?.total;
          // this.purchaseExcelUploadData.createdCount = this.purchaseExcelUploadData.createdCount + 1;
          this.purchaseExcelUploadData.createdCount = res?.message?.per;
          this.uploadPurchaseProgress.progress =
            (this.purchaseExcelUploadData.createdCount * 100) /
            this.purchaseExcelUploadData.totalCount;

          // this.isPurchaseImport = 'Uploaded';
        }

        if (res?.message?.type === 'purchase_import_file_uploaded') {
          this.isPurchaseSocket = true;
          this.uploadPurchaseProgress.status = 'STARTED';
          this.uploadPurchaseProgress.completed = true;
          this.uploadPurchaseProgress.label = 'Uploading Files';
          this.uploadPurchaseProgress.color = 'success';
          this.purchaseExcelUploadData.totalCount = res?.message?.total;
          // this.purchaseExcelUploadData.createdCount = this.purchaseExcelUploadData.createdCount + 1;
          this.purchaseExcelUploadData.createdCount = res?.message?.per;
          this.uploadPurchaseProgress.progress =
            (this.purchaseExcelUploadData.createdCount * 100) /
            this.purchaseExcelUploadData.totalCount;

          // this.isPurchaseImport = 'Uploaded';
        }
        if (res?.message?.type === 'purchase_import_error') {
          this.uploadPurchaseProgress.status = 'ERROR';
          // this.hasPurchaseErrors.status = true;
          this.hasPurchaseErrors.message = res?.message?.message;
          // this.isPurchaseImport = '';
        }

        if (
          res?.message?.type !== 'Bulk_file_invoice_created' &&
          res?.message?.type !== 'Bulk_upload_data' &&
          res?.message?.message !== 'Bulk Invoices Exception'
        )
          return;

        if (res?.message?.type === 'Bulk_file_invoice_created') {
          console.log(' 121 called');
          this.uploadProgress.status = 'STARTED';
          this.uploadProgress.label = 'Uploading Files';
          this.uploadProgress.color = 'secondary';
          this.uploadProgress.file_type = `${
            this.companyInfo?.bulkupload_inovice_file_type === 'xlsx'
              ? 'Excel'
              : this.companyInfo?.bulkupload_inovice_file_type?.toUpperCase()
          } File`;
          this.excelUploadData.totalCount = res?.message?.count;
          if (res?.message?.invoice_count)
            this.excelUploadData.createdCount = res?.message?.invoice_count;

          this.uploadProgress.progress =
            (this.excelUploadData.createdCount * 100) /
            this.excelUploadData.totalCount;

          if (res?.message?.count === res?.message?.invoice_count) {
            this.uploadProgress.data = res.message.data;
            this.uploadProgress.progress = 100;
            this.uploadProgress.color = 'success';
            this.uploadProgress.label = 'Processing Files Successful';
            this.uploadProgress.status = 'SUCCESS';
            this.uploadProgress.file_type = `${
              this.companyInfo?.bulkupload_inovice_file_type === 'xlsx'
                ? 'Excel'
                : this.companyInfo?.bulkupload_inovice_file_type?.toUpperCase()
            } File `; //XML FILE text Replaced
            this.excelUploadData.createdCount = 0;
            this.excelUploadData.totalCount = 0;
            setTimeout(() => {
              this.uploadProgress.status = 'SUCCESS';
              this.excelUploadData.createdCount = 0;
              this.excelUploadData.totalCount = 0;
            }, 1000);
          }
        }
        if (res?.message?.type === 'Bulk_upload_data') {
          console.log('149 called ');
          this.uploadProgress.data = res?.message?.data;
          this.uploadProgress.progress = 100;
          this.uploadProgress.color = 'success';
          this.uploadProgress.label = 'Processing Files Successful';
          this.uploadProgress.file_type = `${
            this.companyInfo?.bulkupload_inovice_file_type === 'xlsx'
              ? 'Excel'
              : this.companyInfo?.bulkupload_inovice_file_type?.toUpperCase()
          } File `;
          setTimeout(() => {
            this.uploadProgress.status = 'SUCCESS';
            this.excelUploadData.createdCount = 0;
            this.excelUploadData.totalCount = 0;
          }, 1000);
        }

        if (res?.message?.message === 'Bulk Invoices Exception') {
          this.execeptionError = true;
          this.execptionData = res?.message;
        }
      });

    // this.socketService.finalizePRCompleted
    //   .pipe(takeUntil(this.destroyEvents))
    //   .subscribe((res: any) => {
    //     console.log(this.socketName, '======', this.socketName, '====', res);
    //     if (
    //       res &&
    //       res?.message?.type === 'Bulk_file_pr_invoice_created_Completed'
    //     ) {
    //       this.socketName = 'Finalize_PR_Completed';
    //       console.log(this.socketName, '////socketName');
    //     }
    //   });
  }

  uploadClose() {
    this.item.emit(false);
  }
}
